import { render, staticRenderFns } from "./WideEventsSearch.vue?vue&type=template&id=27f66daa&"
import script from "./WideEventsSearch.vue?vue&type=script&lang=js&"
export * from "./WideEventsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports